import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import Scrollbars from 'react-custom-scrollbars';
import {
  StyledNextStepButton,
  StyledVerticalGap,
} from './custom-styled-components/_MyCustomSC';
import DeliveryForm from './DeliveryForm';
import PickupForm from './PickupForm';
import CustomService from './CustomService';
import SearchBook from './SearchBook';

import LeftShippingForm from './LeftShippingForm';
import LclTransportMode from './LclTransportMode';


/**
 * @component
 * @category Form Page
 * @subcategory LCL/AIR Tab
 * @name LeftTab
 * @description It's PALLETS/BOXES/CRATES tab with LCL/AIR shipping, transport mode, pickup, delivery, custom service section on form page.
 * <br> <br>
 * **Example**
 * ```js
 *   <LeftTab nextBtnClick={2} onNextBtnClick={()=>{}}/>
 * ```
 */
class LeftTab extends Component {
  state = {};

  componentDidUpdate() {
    const { scrollbars } = this.refs;
    scrollbars.scrollTop(scrollbars.getScrollHeight());
  }

  render() {
    const { nextBtnClick, onNextBtnClick, showFormCustomService } = this.props;
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Scrollbars
          ref="scrollbars"
          autoHeight={true}
          // autoHeightMin={window.innerHeight}
          autoHeightMin={`calc(100vh - 220px)`}
          renderTrackHorizontal={(props) => (
            <div
              {...props}
              style={{
                display: 'none',
              }}
              // className="track-horizontal"
            />
          )}
        >
          <StyledVerticalGap />
          <LeftShippingForm />

          {/* lcl transport mode */}

          <div
            className={
              `${nextBtnClick}` > 0 ? 'my-transition show' : 'my-transition'
            }
          >
            <StyledVerticalGap />
            <LclTransportMode />
          </div>

          {/* pickup & delivery */}
          <div
            className={
              `${nextBtnClick}` > 1 ? 'my-transition show' : 'my-transition'
            }
          >
            <StyledVerticalGap />
            <PickupForm />
            <StyledVerticalGap />
            <DeliveryForm />
          </div>

          {/* Custom service */}
          {showFormCustomService && (
            <div
              className={
                `${nextBtnClick}` > 2 ? 'my-transition show' : 'my-transition'
              }
            >
              <StyledVerticalGap />
              <CustomService />
            </div>
          )}

          {/* Next step btn */}
          <div
            className={
              `${nextBtnClick}` < (showFormCustomService ? 3 : 2)
                ? 'my-transition show'
                : 'my-transition'
            }
            style={{ width: '870px' }}
          >
            <StyledVerticalGap />
            <StyledNextStepButton onClick={onNextBtnClick}>
              Next Step
            </StyledNextStepButton>
          </div>

          <StyledVerticalGap />
          <SearchBook nextBtnClick={nextBtnClick} />
        </Scrollbars>
      </div>
    );
  }
}


LeftTab.propTypes = {
  /**
   * whether to show custom service section
   */
  showFormCustomService: PropTypes.string,
  /**
   * How many times next-step button is clicked
   */
  nextBtnClick: PropTypes.number,
  /**
   * it's invoked when next-step button is clicked
   */
  onNextBtnClick: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    showFormCustomService: state.code_config.showFormCustomService,
  };
};

export default connect(mapStateToProps, actions)(LeftTab);
